import React from 'react';
import { makeStyles } from '@material-ui/core';
import { COLOR_BLACK, COLOR_WHITE, COLOR_STEAK_SAUCE } from '../../../../colors';

const useStyles = makeStyles((theme)=> ({
    schoolInfographicWrap: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: '42px 24px 64px',
    },
    heading: {
        fontSize: '34px',
        lineHeight: '48px',
        fontWeight: 900,
        textAlign: 'center',
    },
    schoolsList: {
        marginTop: 24,
    },
    schoolsListItem: {
        display: 'flex',
        flex: 1,
        justifyContent: 'start center',
        minHeight: 116,
        marginBottom: 24,
        '&:last-of-type': {
            marginBottom: 0,
        }
    },
    schoolsListItemColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    ratingDisc: {
        display: 'flex',
        minWidth: 80,
        height: 80,
        flexDirection: 'column',
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
        justifyContent: 'center',
        marginRight: 24,
        borderRadius: '50%',
    },
    ratingWrap: {
        fontSize: 20,
        lineHeight: '28px',
        textAlign: 'center',
    },
    schoolStatus: {
        color: COLOR_STEAK_SAUCE,
        fontSize: 16,
        lineHeight: '22px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        fontWeight: 700,
        marginBottom: 2,
    },
    schoolName: {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 900,
    },
    schoolGradesDistance: {
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '28px',
        letterSpacing: '0.15px',
    }
}));

export function SchoolsInfographic({
    schools,
}) {
    const classes = useStyles();
    return (
        <div className={classes.schoolInfographicWrap}>
            <div className={classes.heading}>Schools in the area</div>

            {schools?.length > 0 && (<div className={classes.schoolsList}>
                {schools.filter(Boolean).map((school)=> (
                    <div className={classes.schoolsListItem}
                        key={`${school.name} ${school.range}`}
                    >
                        <div className={classes.schoolsListItemColumn}>
                            <div className={classes.ratingDisc}>
                                <div className={classes.ratingWrap}>
                                    <span style={{
                                        fontSize: 28,
                                        fontWeight: 900,
                                    }}>{school.rating || '-'}</span>/10
                                </div>
                            </div>
                        </div>

                        <div className={classes.schoolsListItemColumn}>
                            {school.status && (<div className={classes.schoolStatus}>{school.status}</div>)}
                            {school.name && (<div className={classes.schoolName}>{school.name}</div>)}
                            <div className={classes.schoolGradesDistance}>
                                {school.range && (<span style={{marginRight: 13}}>Grades: {school.range}</span>)}
                                {school.distance && (<span>Distance: {school.distance}</span>)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>)}
        </div>
    );
}
